<template>
    <div class="footer">
      <div class="content">
        <div class="logo">
           <img src="../../../assets/images/shilin/ft_logo.png">
        </div>
        <div class="ft-infor">
          <p>Copyright 2021 Shilin.com All Rights Reserved. 版权所有：阿斯哈图石林风景区</p>
          <p>地址：内蒙古自治区克什克腾旗 <span>电话：0476-5070998</span>
            <span>
              <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" class="version-num">蒙ICP备16005155号-5</a>
            </span>
          </p>
        </div>
        <div class="ewm">
           <img src="../../../assets/images/shilin/ewm.png">
           <p>更多优惠</p>
           <p>关注我们</p>
        </div>
      </div>
       
    </div>
</template>
<script>
export default {
    
    data() {
    return {
     
    };
  },
    methods: {
      
  }
}
</script>
<style scoped lang="scss">

.footer{
  width: 100%;
  background:url('../../../assets/images/shilin/ftbg.jpg') repeat-y;
  height: 205px;
  margin-top: 20px;
  .content{
    width: 1200px;
    margin: 0 auto;
  }
  .logo{
    width: 192px;
    height: 60px;
    float: left;
    margin-top: 60px;
  }
  .ft-infor{
    padding-top: 40px;
    float: left;
    width: 700px;
    p {
      text-align: center;
      padding-top: 20px;
      font-size: 14px;
      color: #c8f2b1;
      &:first-child{
        margin: 0 auto;
        border-bottom: 1px solid #98d685;
        width: 500px;
        padding-bottom: 10px;
      }
      .version-num {
        font-size: 14px;
        color: #c8f2b1;
      }
    }
  }
 .ewm{
      width: 147px;
      float: right;
      margin-top: 50px;
      img{
        width: 104px;
        height: 100px;
        display: block;
        float: left;
        margin-right: 5px;
      }
      p{
        width: 15px;
        font-size: 14px;
        color: #fff;
        float: left;
        margin-top: 5px;
        padding-right: 3px;
      }
    }

}

</style>


// WEBPACK FOOTER //
// src/pages/shilin/components/footer.vue